import React from "react";
import { Dialog } from '@fluentui/react-northstar'
import PropTypes from "prop-types";
import Constants from "../../../constants/text-constants";

const ForgotPasswordErrorDialog = (props) => {
    const { onConfirm } = props;

    return (
        <Dialog
            data-testid="forgotPasswordErrorDialog"
            className="maxWidthDialog"
            confirmButton={Constants.TRY_AGAIN}
            header={Constants.UNABLE_TO_RESET_PW}
            content={Constants.UNABLE_TO_RESET_PW_DESC}
            open={true}
            onConfirm={onConfirm}
        />);
};

ForgotPasswordErrorDialog.propTypes = {
    onConfirm: PropTypes.func,
};

export default ForgotPasswordErrorDialog;
